<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Carousel from 'svelte-carousel';
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { Splide, SplideSlide } from '@splidejs/svelte-splide';
    import '@splidejs/splide/dist/css/themes/splide-default.min.css';
    import { faWallet,faMoneyBillTransfer,faClockRotateLeft,faHandHoldingDollar,faFutbolBall } from '@fortawesome/free-solid-svg-icons';
    import Device from 'svelte-device-info'
    import Swal from 'sweetalert2'
    //import { page } from '$app/stores';


    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))
    export let params = {};
    let sid = ""
    let pid = ""
    // รูปค่าย: กระดาน MRG ไม่มี logoURL_gmz1 (sync มาเป็นค่าว่าง) — fallback ไป logoURL_custom / logoURL
    function providerImg(prs){
        return prs.logoURL_gmz1 || prs.logoURL_custom || prs.logoURL || ''
    }
    let gameList
    let gametypeList = []
    let device = 'desktop'
    
    async function getProvider() {
        if(sid=='gamehit'){
            if(dataSetting.gamehit){
                gameList = JSON.parse(dataSetting.gamehit)
            }else{
                gameList =[]
            }
        }else{
            const res = await fetch(window.localStorage.getItem("apiurl")+"member/getproviderlist", {
                method: 'POST',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                    'x-api-appid': window.localStorage.getItem("appid")
                },
                body: qs.stringify({
                    tab:sid,
                    platform:pid
                })
            })
            const json = await res.json()
            if (json.statusCode==200) {
                gameList = json.payload
            } else {
                gameList = []
                throw new Error(json);
            }
        }
        
    }
    async function getPlatform() {
        let obcs = document.getElementById('btns-ufabet')
        if(obcs){
            obcs.classList.remove("active");
        }
        
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getplatform", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({prefix:pid})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            //gametypeList.unshift("gamehit");
            gametypeList = json.payload
        } else {

            throw new Error(json);
        }
    }
    
    let platformList = []
    let platformDF = []
    let prefixDF = '';
    let ufabetset = false;
    let ufabetid = '';
    async function getPlatformDF() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getplatformlist", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            platformList = json.payload
             let dataPL = []
            if(dataSetting.platform){
                dataPL = JSON.parse(dataSetting.platform)
            }
            for await (let abs of platformList) {
                if(dataPL.length>0){
                    var xx= 0;
                    for await (let val2 of dataPL) {
                        if(abs._id==val2){
                            xx=xx+1
                            break;
                        }
                    }
                    if(xx>0){
                        if(abs.platform_prefix!='UFA'){prefixDF=abs.platform_prefix}
                        if(abs.platform_prefix=='UFA'){
                            ufabetset = true
                        }
                    }
                }else{
                        if(abs.platform_prefix!='UFA'){prefixDF=abs.platform_prefix}
                        if(abs.platform_prefix=='UFA'){
                            ufabetset = true
                        }
                }
            }
		} else {

            throw new Error(json);
		}
    }
    async function getGameURL(mgds) {

        Swal.fire({
            title: 'กรุณารอสักครู่',
            html: 'เรากำลังพาคุณเข้าสู่เกม ขอให้โชคดี Good Luck.',
            timer: 5000,
            timerProgressBar: true,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            },
            willClose: () => {
                
            }
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
                
            }
        })
        
        if(Device.isPhone){
            device = 'mobile'
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/startgame", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                _id:mgds,
                device:device,
                type:""
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            transferCash(json.txid,json.payload)
		} else {
            if(json.statusCode==205){
                Swal.fire({
                    title: "ไม่สามารถเล่นเกมได้",
                    text: json.message,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "ยกเลิกโปรโมชั่น",
                    cancelButtonText: "ปิด"
                    }).then((result) => {
                    if (result.isConfirmed) {
                        clearpromotion()
                    }
                });
            }else{
                Swal.fire(json.message)
            }
            throw new Error(json);
		}
        
    }
    async function transferCash(txid,url) {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/transfercash", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                txid:txid
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            // window.location = url
            window.open(url) 
            popUpGame(url)
		} else {

            throw new Error(json);
		}
    }
    async function popUpGame(url) {
        Swal.fire({
            title: '<strong><a href="'+url+'" target="_blank">เข้าสู่เกม</a></strong>',
            icon: 'info',
            html:
                'หากระบบไม่เปิดหน้าเกมอัตโนมัติกรุณาคลิกที่ปุ่ม <a href="'+url+'" target="_blank">เข้าสู่เกม</a>',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton:false,
            focusConfirm: false
        })
    }
    async function clearpromotion() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/clearpromotion", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            Swal.fire(json.message)
		} else {
            Swal.fire(json.message)
            throw new Error(json);
		}
    }
    let isLoad = true
    async function setHeader(types) {
        isLoad = false
        var obc1 = document.getElementById('btns-casino')
        obc1.classList.remove("active");

        var obc2 = document.getElementById('btns-sport')
        obc2.classList.remove("active");

        var obc3 = document.getElementById('btns-game')
        obc3.classList.remove("active");

        var obc4 = document.getElementById('btns-card')
        obc4.classList.remove("active");
        
        var obc5 = document.getElementById('btns-fish')
        obc5.classList.remove("active");

        var obc6 = document.getElementById('btns-lotto')
        obc6.classList.remove("active");

        var obc7 = document.getElementById('btns-other')
        obc7.classList.remove("active");

        var obc8 = document.getElementById('btns-ufabet')
        obc8.classList.add("active");
        
    }
    let carousel;
    let names = '';
    let promise
    $: {
        
        if (params && params.sid) {
            isLoad = true
            sid = params.sid
            pid = params.pid
            promise = getProvider()
            getPlatform()
            getPlatformDF()
            
        } 
    }
    let optionss = {
    rewind : true,
    perPage: 4,
    autoWidth:true,
    gap    : '.2rem',
  }
</script>
<div class="default-home">
<div class="row   mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    
    <div class="themes-home-default lists" style="margin-left:0px;margin-right:0px;padding:0px;margin-bottom: 5px;">
    <div class="justify-content-center mb-1" style="margin: 0px !important;width: 100%;padding:0px !important;">
            <div class="row blog-home-games providers" style="margin: 0px;">
            {#each gametypeList as prs}
           
            <div class="col-3"  style="padding-bottom: 0px !important;">
                {#if sid==prs}
                <button type="button" class="btn-games active " id="btns-{prs}" on:click={() => push('/provider/'+pid+'/'+prs)}>
                    <img decoding="async" src="./assets/icon/{prs}.png?v=2" alt="{prs}" class="img-fluid -ic-menu entered lazyloaded">
                    <div class="-text-provider-wrapper">
                        <div class="-text-nav-menu -title-mobile">
                            {#if prs=='LIVECASINO' || prs=='casino'}{names='คาสิโน'}
                            {:else if prs=='SPORT' || prs=='sport'}{names='กีฬา'}
                            {:else if prs=='EGAMES' || prs=='game'}{names='สล็อต'}
                            {:else if prs=='POKER' || prs=='card'}{names='เกมไพ่'}
                            {:else if prs=='lotto'}{names='หวย'}
                            {:else if prs=='fish'}{names='ยิงปลา'}
                            {:else if prs=='TRADING' || prs=='other'}{names='อื่นๆ'}
                            {/if}
                        </div>
                    </div>
                </button>
                {:else}
                <button type="button" class="btn-games" on:click={() => push('/provider/'+pid+'/'+prs)}>
                    <img decoding="async" src="./assets/icon/{prs}.png?v=2" alt="{prs}" class="img-fluid -ic-menu entered lazyloaded">
                    <div class="-text-provider-wrapper">
                        <div class="-text-nav-menu -title-mobile">
                            {#if prs=='LIVECASINO' || prs=='casino'}{names='คาสิโน'}
                            {:else if prs=='SPORT' || prs=='sport'}{names='กีฬา'}
                            {:else if prs=='EGAMES' || prs=='game'}{names='สล็อต'}
                            {:else if prs=='POKER'  || prs=='card'}{names='เกมไพ่'}
                            {:else if prs=='lotto'}{names='หวย'}
                            {:else if prs=='fish'}{names='ยิงปลา'}
                            {:else if prs=='TRADING'  || prs=='other'}{names='อื่นๆ'}
                            {/if}
                        </div>
                    </div>
                </button>
                {/if}
            </div>
            {/each}
            {#if ufabetset}
            <div class="col-3"  style="padding-bottom: 0px !important;">
                <button type="button" class="btn-games" id="btns-ufabet" on:click={() => setHeader('UFA')}>
                    <img decoding="async" src="./assets/icon/ufa-icon.png" alt="UFABET" class="img-fluid -ic-menu entered lazyloaded">
                    <div class="-text-provider-wrapper">
                        <div class="-text-nav-menu -title-mobile"><span style="color: gold;">UFA</span>BET</div>
                    </div>
                </button>
            </div>
            {/if}
        </div>        
    </div>
    </div>
    <div class="col-12 text-center mt-0 mb-1">
        <h6 class="header-n">
        {#if isLoad}
            {#if sid=='LIVECASINO' || sid=='casino'}คาสิโน
            {:else if  sid=='SPORT' || sid=='sport'}กีฬา
            {:else if  sid=='EGAMES' || sid=='game'}สล็อต
            {:else if sid=='POKER' || sid=='card'}เกมไพ่
            {:else if sid=='lotto' }หวย
            {:else if sid=='fish'}ยิงปลา
            {:else if sid=='TRADING' || sid=='other'}เทรด
            {/if}
        {:else}
        UFABET
        {/if}
           
        </h6>
    </div>
    <div class="col-12 pb-5 mb-5" style="min-height: 500px;">
         {#if isLoad}
        <div class="row d-flex justify-content-center">
            {#await promise}
            <span class="text-white">Loading...</span>
            {:then number}
            {#if gameList.length>0}
            {#each gameList as prs}
            {#if prs.active=='O'}
            <div class="col-4 text-center mb-1 pointer" style="position:relative;">
                <a href="#/gamelist/{prs._id}" style="text-decoration: none;">
                    <img src="{providerImg(prs)}" class="img-fluid" alt="{prs.provider}" style="border-radius: 10px;"><br />
                    <span class="text-white text-sm"><b>{prs.providerName}</b></span>
                </a>
            </div>
            {:else}
            <div class="col-4 text-center mb-1 pointer" style="position:relative;">
                <a href="javascript:;" style="text-decoration: none;">
                    <img src="{providerImg(prs)}" class="img-fluid" alt="{prs.provider}" style="border-radius: 10px;"><br />
                    <span class="text-white text-sm"><b>{prs.providerName}</b></span>
                </a>
                <div style="background-color: black;position:absolute;width:100%;height:100%;opacity:0.5;top:0px;border-redius:10px;width:80%;color:white;" class="pt-4">ติด Promotion ไม่สามารถเล่นได้</div>
            </div>
            {/if}
            {/each}
            {:else}
            <div class="col-12 ">
                <div class="blog-coming" style="text-align: center;">
                    <b>Coming soon.</b>
                </div>
            </div>
            {/if}
            {/await}
        </div>
        {:else}
        <div class="row d-flex justify-content-center">
            <div class="col-sm-4 col-4"></div>
            <div class="col-4 col-sm-4 text-center mb-1 pointer" style="position:relative;">
                <a href="javascript:;"  on:click={() => getGameURL('UFA')}  style="text-decoration: none;">
                    <img src="./assets/webgame/UFABET/ufabet.png" class="img-fluid" alt="UFABET" style="border-radius: 10px;margin-bottom: 5px;"><br />
                    <span class="text-white text-sm mt-2"><b>UFABET</b></span>
                </a>
            </div>
            <div class="col-sm-4 col-4"></div>
        </div>
        {/if}
    </div>
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3">
        <HeaderThemes/>
    </div>
    <div class="col-12 text-center mt-0 blog-providers {pid} blog-darkred-h1">
        <div class="row divs p-0 ">
            
            {#each gametypeList as prs}
            <div class="col">
                {#if sid==prs}
                <button type="button" class="btn-games active" on:click={() => push('/provider/'+pid+'/'+prs)}>
                    <img decoding="async" src="./assets/icon/{prs}.png?v=2" alt="{prs} AMB" class="img-fluid -ic-menu entered lazyloaded">
                    <div class="-text-provider-wrapper">
                        <div class="-text-nav-menu -title-mobile">{prs.toUpperCase()}</div>
                    </div>
                </button>
                {:else}
                <button type="button" class="btn-games" on:click={() => push('/provider/'+pid+'/'+prs)}>
                    <img decoding="async" src="./assets/icon/{prs}.png?v=2" alt="{prs} AMB" class="img-fluid -ic-menu entered lazyloaded">
                    <div class="-text-provider-wrapper">
                        <div class="-text-nav-menu -title-mobile">{prs.toUpperCase()}</div>
                    </div>
                </button>
                {/if}
            </div>
            {/each}
        </div>        
    </div>
    <div class="col-12 text-center blog-providers mt-0 mb-1 blog-darkred-s1 ps-2 pe-2">
        <h6 class="head-title">{sid}</h6>
    </div>
    <div class="col-12 pb-5 " style="min-height: 500px;">
        <div class="row d-flex justify-content-center blog-darkred-s2 ps-2 pe-2">
            {#await promise}
            <span class="text-white">Loading...</span>
            {:then number}
            {#each gameList as prs}
            {#if prs.active=='O'}
            <div class="col-4 text-center mb-1 pointer" style="position:relative;">
                <a href="#/gamelist/{prs._id}" target="_blank" style="text-decoration: none;">
                    <img src="{providerImg(prs)}" class="img-fluid" alt="{prs.provider}" style="border-radius: 10px;"><br />
                    <span class="text-white text-sm"><b>{prs.providerName}</b></span>
                </a>
                
            </div>
            {:else}
            <div class="col-4 text-center mb-1 pointer" style="position:relative;">
                <a href="javascript:;" target="_blank" style="text-decoration: none;">
                    <img src="{providerImg(prs)}" class="img-fluid" alt="{prs.provider}" style="border-radius: 10px;"><br />
                    <span class="text-white text-sm"><b>{prs.providerName}</b></span>
                </a>
                <div style="background-color: black;position:absolute;width:100%;height:100%;opacity:0.5;top:0px;border-redius:10px;width:80%;color:white;" class="pt-4">ติด Promotion ไม่สามารถเล่นได้</div>
            </div>
            {/if}
            {/each}
            {/await}
        </div>
    </div>
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    @media only screen and (max-width: 767px) {
        .default-home{
            margin-bottom: 5rem !important;
        }
        :global(.themes-home-default .-text-nav-menu.-title-mobile){
            font-size: 16px;
            position: relative;
            top: -4px;
        }
        :global(.themes-home-default .row){
            margin-left: 0px !important;
            margin-right: 0px !important;
        }
        .themes-home-default.lists{
            width: 100% !important;
        }
        
    }
    :global(.splide){
        width: 354px !important;
        padding: 0px !important;
        margin: 0px !important;
    }
    :global(.splide__pagination){
        display: none !important;
    }
    :global(.splide .splide__arrow.splide__arrow--prev){
        position: absolute;
        left: -10px;
        top: 32px;
        width: 15px;
        height: 15px;
        font-size: 0.5rem;
    }
    :global(.splide .splide__arrow.splide__arrow--next){
        position: absolute;
        right: -10px;
        top: 32px;
        width: 15px;
        height: 15px;
        font-size: 0.5rem;
    }
    .btn-gd{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300;
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    .btn-games {
        margin: 0;
        padding: 7px 10px;
        background: linear-gradient(155deg, #424242, #101010);
        position: relative;
        box-shadow: 0 5px 10px #000000b0;
        border-radius: 10px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: all .3s;
        font-size: 16px;
        position: relative;
        color: #FFF;
        width: 75px !important;
        border: 0px;
    }
    .row.divs .col {
        padding-left: 5px !important;
        padding-right: 5px !important;
    }
    .btn-games img {
        max-width: 35px !important;
    }
    .btn-games .-title-mobile {
        font-size: 10px;
    }
    .btn-games.active, .btn-games:hover {
        background: linear-gradient(181deg,#ffd34e,#794909);
    }
    @media only screen and (max-width: 400px) {
        .themes-home-default .-text-nav-menu.-title-mobile{
            font-size: 14px !important;
        }
    }
</style>